const xmlns = "http://www.w3.org/2000/svg";

function applyAttributeObj(element:any, attributes: Record<string,string>): any {
    for (let key in attributes) {
        element.setAttribute(key, attributes[key]);
    }
    return element;
}

export const createPointerSvg = () => {
    let svg = document.createElementNS(xmlns, "svg");
    svg = applyAttributeObj(svg, {
        id: "pointer", width: "22", height: "20"
    });
    let g = document.createElementNS(xmlns, "g");
    g.setAttribute("transform", "matrix(1.3101052,0,0,1.3101052,-6.2175751,-9.0274217)");
    let arrowbody = document.createElementNS(xmlns, "rect");
    arrowbody = applyAttributeObj(arrowbody, {
        x: "12.5", y: "13.6", transform: "matrix(0.9221,-0.3871,0.3871,0.9221,-5.7605,6.5909)", width: "2", height: "8"
    });
    let arrowhead = document.createElementNS(xmlns, "polygon");
    arrowhead.setAttribute("points", "12.2,15.6 12.6,15.5 17.4,15.5 9.2,7.3 9.2,18.5");
    g.appendChild(arrowbody);
    g.appendChild(arrowhead);
    svg.appendChild(g);
    return svg;
}

/** Generates a 22x20 Desk Icon SVG */
export const createDeskSvg = () => {

    let deskRect = document.createElementNS(xmlns, "rect");
    deskRect.classList.add("deskRect");
    deskRect = applyAttributeObj(deskRect, {
        ry: "3",
        rx: "3",
        y: "4",
        x: "1",
        height: "17",
        width: "18",
        fill: "#cccccc",
        style: "stroke:none;"
    });
    let availabilityCircle = document.createElementNS(xmlns, "ellipse");
    availabilityCircle.classList.add("availability");
    availabilityCircle = applyAttributeObj(availabilityCircle, {
        ry: "7",
        rx: "7",
        cy: "10",
        cx: "10",
        fill: "#ffffff",
        style: "stroke:#808080;stroke-width:1.1;stroke-miterlimit:4;stroke-dasharray:none"
    });
    
    // x - marking non-availability
    let clippedGroup = document.createElementNS(xmlns, "g");
    clippedGroup.setAttribute("clip-path", "url(#nonAvailability)");
    clippedGroup.classList.add("notAvailableIcon");
    let unavailableLine1 = document.createElementNS(xmlns, "line");
    unavailableLine1 = applyAttributeObj(unavailableLine1, {
        x1: "3", x2: "17", y1: "3", y2: "16", stroke: "#aa0000", "stroke-width": "2"
    });
    let unavailableLine2 = document.createElementNS(xmlns, "line");
    unavailableLine2 = applyAttributeObj(unavailableLine2, {
        x1: "17", x2: "3", y1: "3", y2: "16", stroke: "#aa0000", "stroke-width": "2"
    });
    clippedGroup.appendChild(unavailableLine1);
    clippedGroup.appendChild(unavailableLine2);
    
    let mainGroup = document.createElementNS(xmlns, "g");
    mainGroup.appendChild(deskRect);
    mainGroup.appendChild(availabilityCircle);
    mainGroup.appendChild(clippedGroup);

    return mainGroup;
}

export const createDoorSvg = () => {
    let mainGroup = document.createElementNS(xmlns, "g");
    mainGroup = applyAttributeObj(mainGroup, {
        width: "20", height: "20"
    });
    let door = document.createElementNS(xmlns, "path");
    door = applyAttributeObj(door, {
        d: "m1,22.5l10,-11c0,0.08 6,1.5 6.8,11z",
        fill: "#fff",
        stroke: "#e3e3e3",
        strokeDasharray: "29", 
        strokeLinecap:"round",
        strokeLinejoin:"round"
    });
    let line = document.createElementNS(xmlns, "line");
    line = applyAttributeObj(line, {
        x1: "1", x2: "11", y1: "22.5", y2: "11", stroke: "#000"
    });
    mainGroup.appendChild(door);
    mainGroup.appendChild(line);
    return mainGroup;
};